var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    x: -0.5,
    y: 2.5,
    stroke: "#516F90",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#516F90",
    d: "M0 7h14v1H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    x: 3,
    fill: "#516F90",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    x: 10,
    fill: "#516F90",
    rx: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6a54a00b5ef622f5f039242a8fa99d88.svg";
export { ForwardRef as ReactComponent };